module.exports = DOUBAN_VENDORS_DLL;